// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonContent, IonFooter, IonGrid, IonModal, IonToolbar } from "@ionic/react"
import { useSectionDimensions } from "./useSectionDimensions"
import './SectionContainer.scss'
import { useScreenOrientation } from "./useScreenOrientation"


interface ServiceNotAvailableModalProps {
  children?: React.ReactNode[]
  grid?: boolean
  isOpen: boolean
}


const SectionModal: React.FC<ServiceNotAvailableModalProps> = ({
  children,
  grid,
  isOpen
}) => {
  const [content, footer] = children || []
  const {classes} = useScreenOrientation()
  const {containerStyle, contentClasses} = useSectionDimensions()
  const render: () => React.ReactNode = () => {
    if (!grid) { return content }
    return (
      <IonGrid>{content}</IonGrid>
    )
  }

  return (
    <IonModal
      className={[...classes, "page-modal"].join(" ")}
      isOpen={isOpen}
    >
      <IonContent fullscreen scrollY={false}>
        <div
          className="section-container"
          style={
            {
              ...containerStyle,
            } as React.CSSProperties
          }
        >
          <div className={contentClasses.join(" ")}>
            <main>{render()}</main>
          </div>
        </div>
      </IonContent>
      {(footer !== undefined) ? (
        <IonFooter className="navigation">
          <IonToolbar>{footer}</IonToolbar>
        </IonFooter>
      ) : null}
    </IonModal>
  )
}
  
  export { SectionModal }